import React, { useEffect, useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

type GalleryItem = {
  index?: number
  originalData: any
  thumbnailData: any
  alt: string
  thumbnail?: string
}

type Props = {
  items: GalleryItem[]
}

const ProductImageGalleryClient: React.FC<Props> = ({ items }) => {
  const [Gallery, setGallery] = useState<any>(null)

  useEffect(() => {
    let mounted = true
    try {
      // Use require at runtime to avoid TypeScript compile-time dynamic import restrictions
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const mod = require('react-image-gallery')
      if (mounted) setGallery(() => mod.default)

      // Load CSS by injecting a stylesheet link so bundlers don't include it in the server bundle
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  // load the gallery CSS from the static assets so it's served at runtime
  link.href = '/styles/image-gallery.css'
  link.crossOrigin = 'anonymous'
  document.head.appendChild(link)
    }
    catch (err) {
      console.error('Failed to load image gallery', err)
    }

    return () => {
      mounted = false
    }
  }, [])

  if (!Gallery) {
    const first = items && items.length ? items[0] : null
    return first ? <GatsbyImage loading={"eager"} image={first.originalData} alt={first.alt} /> : null
  }

  const GalleryComp = Gallery

  return (
    <GalleryComp
      items={items as any}
      renderItem={(item: any) => (
        <GatsbyImage loading={item.index === 0 ? 'eager' : 'lazy'} image={item.originalData} alt={item.alt} />
      )}
      renderThumbInner={(item: any) => (
        <GatsbyImage image={item.thumbnailData} alt={item.alt} loading="eager" />
      )}
      thumbnailPosition="bottom"
      showThumbnails={true}
      showNav={true}
      lazyLoad={true}
      infinite={true}
      showPlayButton={false}
      showFullscreenButton={false}
    />
  )
}

export default ProductImageGalleryClient
